module.exports = __webpack_public_path__ + "media/images/icons/fullscreen-exit-8852de464bb3e0dd1d123af634a5f9cc.svg";